export class TelemetrySystemAttributeHelper {
    public static readonly typicalApplication = 'typische_Anwendung';
}
